/** @format */

export const emotionList = [
  {
    emotion_id: 1,
    emotion_img: '/assets/emotion1.png',
    emotion_descript: 'すごく嬉しい',
  },
  {
    emotion_id: 2,
    emotion_img: '/assets/emotion2.png',
    emotion_descript: '嬉しい',
  },
  {
    emotion_id: 3,
    emotion_img: '/assets/emotion3.png',
    emotion_descript: '普通',
  },
  {
    emotion_id: 4,
    emotion_img: '/assets/emotion4.png',
    emotion_descript: '悲しい',
  },
  {
    emotion_id: 5,
    emotion_img: '/assets/emotion5.png',
    emotion_descript: 'すごく悲しい',
  },
];
